import React from "react";

import styles from "../../../../styles/secrets-drawers.module.scss";
import { Drawer } from "../../../components/Drawer";
import { Button } from "../../../components/Button";
import { EnvironmentsAPI } from "../../../../providers/EnvironmentsAPI";
import { OlgaEnvironmentsAPI } from "../../../../providers/OlgaEnvironmentsAPI";
import { EnvironmentStorage } from "../../../tools/EnvironmentStorage";
import { Checkbox } from "../../../components/Checkbox";
import { Label } from "../../../components/Label";
import { Hairline } from "../../../components/Hairline";
import { Environment } from "../../../core/Environment";

export default class ExtraMenusDrawer extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            cashback: {
                enabled: false,
            },
            beneficios: {
                enabled: false,
            },
            avaliacoes: {
                enabled: false,
            },
        };
    }

    async componentDidMount() {
        const environmentId = await EnvironmentStorage.getSelectedEnvironment();
        const extra_menus = await EnvironmentsAPI.getConfigurationsByAlias(environmentId, 'extra_menus') || {};

        this.setState({
            cashback: {
                enabled: extra_menus?.cashback?.enabled || false,
            },
            beneficios: {
                enabled: extra_menus?.beneficios?.enabled || false,
            },
            avaliacoes: {
                enabled: extra_menus?.avaliacoes?.enabled || false,
            }
        })
    }

    async save() {
        const { cashback, beneficios, avaliacoes } = this.state;

        this.setState({ loading: true });
        const environmentId = await EnvironmentStorage.getSelectedEnvironment();
        const extra_menus = await EnvironmentsAPI.getConfigurationsByAlias(environmentId, 'extra_menus') || {};

        const new_extra_menus = {
            ...extra_menus,
            cashback,
            beneficios,
            avaliacoes,
        }

        const extraMenusResponse = await EnvironmentsAPI.putConfigurationsByAlias(
            environmentId, 'extra_menus',
            { extra_menus: new_extra_menus }
        );

        if (extraMenusResponse.getErrors([]).length > 0) {
            alert({
                text: extraMenusResponse.getErrors()[0],
                buttonText: "Ok"
            });
            this.setState({ loading: false });
            return false;
        }

        const olgaConfigurations = Environment.configurations;
        const newExternalMenus = {
            cashback: {
                enabled: !new_extra_menus?.cashback.enabled,
            },
            beneficios: {
                enabled: !new_extra_menus?.beneficios.enabled,
            },
            avaliacoes: {
                enabled: !new_extra_menus?.avaliacoes.enabled,
            }
        };

        if (!olgaConfigurations?.external_menus) {
            await OlgaEnvironmentsAPI.postExternalMenusConfigs(newExternalMenus);
        } else {
            await OlgaEnvironmentsAPI.putExternalMenusConfigs(newExternalMenus);
        }

        const environmentConfigurations = EnvironmentStorage.getConfigurations();

        EnvironmentStorage.setConfigurations({
            ...environmentConfigurations,
            extra_menus: new_extra_menus
        });

        await Environment.installConfigurations();

        alert({
            text: "Configuração alterada com sucesso",
            buttonText: "Ok"
        });

        this.setState({ loading: false });
        return true;
    }

    render() {
        const { loading, cashback, beneficios, avaliacoes } = this.state;
        const { visible, onClose } = this.props;

        return (
            <Drawer visible={visible} onClose={onClose} closeInFade title="Menus benefícios e avaliação" >
                <div className={styles.secretDrawerContainer}>

                    <div className={styles.container}>
                        <Label text="Cashback" />
                        <Checkbox
                            name={`cashback`}
                            design="two"
                            checked={cashback?.enabled}
                            onChange={(value) => this.setState({ cashback: { enabled: value } })}
                        >
                            Habilitar menu Cashback
                        </Checkbox>
                        <Hairline />

                        <Label text="Benefícios avulsos" />
                        <Checkbox
                            name={`beneficios`}
                            design="two"
                            checked={beneficios?.enabled}
                            onChange={(value) => this.setState({ beneficios: { enabled: value } })}
                        >
                            Habilitar menu Benefícios avulsos
                        </Checkbox>
                        <Hairline />

                        <Label text="Avaliações" />
                        <Checkbox
                            name={`avaliacoes`}
                            design="two"
                            checked={avaliacoes?.enabled}
                            onChange={(value) => this.setState({ avaliacoes: { enabled: value } })}
                        >
                            Habilitar menu Avaliações
                        </Checkbox>
                    </div>
                    <div className={styles.footer}>
                        <Button
                            design="primary"
                            className="w-100"
                            onClick={() => this.save()}
                            loading={loading}
                            disabled={loading}
                        >
                            Salvar
                        </Button>
                    </div>
                </div>
            </Drawer>
        );
    }
}
